const mutations: any = {
  setSyncLoading(state: any, status: boolean) {
    console.log('进来了吗');
    state.syncLoading = status;
  },
};
export default mutations;
